import { useAuth } from "../../context/Auth";
import { NavbarArrowDownDarkIcon, NavbarArrowDownIcon } from "../../icons/Icon";
import styles from "./FromComponent.module.css";
import { useState, useEffect, useRef } from "react";

const VerticalDropDown = ({
  label,
  options,
  dropDownText,
  star,
  value,
  multiple = false,
  onchange,
  height,
  fontSize,
  disableOpen = false,
  padding,
}) => {
  const { mode } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(multiple ? [] : null);
  const dropdownRef = useRef(null);

  const handleOptionSelect = (option) => {
    if (multiple) {
      setSelectedOptions((prevSelected) => {
        const isSelected = prevSelected.some(
          (item) => item.value === option.value
        );
        const newSelection = isSelected
          ? prevSelected.filter((item) => item.value !== option.value)
          : [...prevSelected, option];

        setTimeout(() => {
          onchange(newSelection);
        }, 0);

        return newSelection;
      });
    } else {
      setSelectedOptions(option);
      setTimeout(() => {
        onchange(option);
      }, 0);
      setIsOpen(false);
    }
  };

  const selectAll = () => {
    setSelectedOptions(options);
    onchange(options);
  };

  const removeAll = () => {
    setSelectedOptions([]);
    onchange([]);
  };

  const handleItemRemove = (option) => {
    const newSelection = selectedOptions.filter((item) => item !== option);
    setSelectedOptions(newSelection);
    onchange(newSelection);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  useEffect(() => {
    setSelectedOptions(value || (multiple ? [] : null));
  }, [value, multiple]);

  return (
    <div className={styles.vertical_dropdown_container} ref={dropdownRef}>
      {label && (
        <div className={styles.multi_selection}>
          <label
            className={styles.vertical_dropdown_label}
            style={mode ? { color: "#fff" } : {}}
          >
            {label}
            {star && <span style={{ color: "red" }}>*</span>}
          </label>
          {multiple && (
            <div>
              <span onClick={selectAll} style={{ color: mode && "#7698FF" }}>
                Select All
              </span>
              <span onClick={removeAll} style={{ color: "#F93E3E" }}>
                Remove All
              </span>
            </div>
          )}
        </div>
      )}

      <div
        className={styles.vertical_custom_select}
        style={mode ? { borderColor: "#1b1d21" } : {}}
      >
        <div
          className={styles.vertical_dropdown_trigger}
          style={{
            height: height && height,
            fontSize: fontSize && fontSize,
            backgroundColor: mode && "#1b1d21",
            borderColor: mode && "#1b1d21",
            cursor: disableOpen ? "text" : "pointer",
          }}
          onClick={() => {
            if (!disableOpen) setIsOpen(!isOpen);
          }}
        >
          <div
            className={styles.vertical_dropdown_placeholder}
            style={{ fontSize: fontSize && fontSize }}
          >
            {!multiple &&
              (value ? (
                <span
                  style={{
                    fontSize: fontSize && fontSize,
                    color: mode ? "#FFFFFF" : "#1b1d21",
                  }}
                >
                  {value.label}
                </span>
              ) : (
                <span style={{ fontSize: fontSize && fontSize }}>
                  {dropDownText}
                </span>
              ))}
            {multiple &&
              (value ? (
                <span style={{ fontSize: fontSize && fontSize }}>
                  {selectedOptions.length > 0
                    ? "Selected Option(s) " + selectedOptions.length
                    : ""}
                </span>
              ) : (
                <span style={{ fontSize: fontSize && fontSize }}>
                  {dropDownText}
                </span>
              ))}
            {!disableOpen && (
              <>
                {mode ? <NavbarArrowDownDarkIcon /> : <NavbarArrowDownIcon />}
              </>
            )}
          </div>
        </div>
        {isOpen && (
          <ul
            className={styles.vertical_dropdown_list}
            style={
              mode ? { backgroundColor: "#232529", borderColor: "#232529" } : {}
            }
          >
            {options?.map((option, index) => {
              const isSelected = multiple
                ? selectedOptions?.some((o) => o.value === option.value)
                : value?.value === option.value;

              return (
                <li
                  key={index}
                  className={`${styles.vertical_dropdown_item} ${
                    mode ? styles.vertical_dropdown_item_dark : ""
                  }`}
                  onClick={() => handleOptionSelect(option)}
                  style={{ fontSize: fontSize && fontSize }}
                >
                  {option.label}
                  {isSelected && (
                    <span style={{ marginLeft: 8, color: "#31974D" }}>✓</span>
                  )}
                </li>
              );
            })}
          </ul>
        )}
      </div>
      {multiple && (
        <div className={styles.selected_items}>
          {selectedOptions.length > 0 ? (
            selectedOptions?.map((opt, index) => (
              <span
                key={index}
                className={styles.selected_item}
                onClick={() => handleItemRemove(opt)}
                style={{
                  fontSize: fontSize && fontSize,
                  padding: padding && padding,
                  backgroundColor: mode && "#1B1D21",
                  color: mode && "#FFFFFF",
                }}
              >
                {opt.label}
                <span
                  style={{ color: mode && "#FFFFFF" }}
                  className={styles.remove_item}
                >
                  &times;
                </span>{" "}
              </span>
            ))
          ) : (
            <span
              className={styles.placeholder_text}
              style={
                mode
                  ? { color: "#fff", fontSize: fontSize && fontSize }
                  : { fontSize: fontSize && fontSize }
              }
            >
              Nothing Selected{" "}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default VerticalDropDown;
